import type { ProgressReportStats } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'

const getStats = (state: ProgressReportStore): ProgressReportStats | null => getReport(state)?.stats || null

export const stats = {
  getStats: (state: ProgressReportStore): ProgressReportStats | null => getStats(state),
  getLessonsAttended: (state: ProgressReportStore): number => getStats(state)?.lessons_attended ?? 0,
  getLessonsExpected: (state: ProgressReportStore): number | null => getStats(state)?.lessons_expected ?? null,
  getLessonsAttendedAllTime: (state: ProgressReportStore): number => getStats(state)?.lessons_attended_all_time ?? 0,
  getTopicsCompleted: (state: ProgressReportStore): number => getStats(state)?.topics_completed ?? 0,
  getPracticeCompleted: (state: ProgressReportStore): number => getStats(state)?.practice_completed ?? 0,
}
